import * as types from "../constants/auth";
import { mapErrorMessage } from "../../Utils/mapErrorMessage";
import { auth } from "../../Utils/auth";
import { toast } from "react-toastify";
import images from "../../Constant/images";
import dayjs from "dayjs";

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
  signupErrors: null,
  token: null,
  refreshToken: null,
  user: null,
  isInstructor: true,
  loginCallback: null,
  userName: "",
  chatGroupId: null,
  chatGroupTitle: null,
  isCardAdded: false,
  isChatOpen: {
    isOpen: false,
    course: {}
  },
  selectedSideMenu: {
    id: 0,
    icon: images.dashboard,
    selectedIcon: images.dashboard1,
    title: "Dashboard",
    isSelected: true,
    navigate: "/dashboard",
  },
  topBarList: [
    {
      id: 0,
      title: "Dashboard",
      isSelected: true,
      navigate: "/dashboard",
    },
    {
      id: 1,
      title: "Courses",
      isSelected: false,
      navigate: "/courses",
    },
    {
      id: 5,
      title: "I-Mail",
      isSelected: false,
      navigate: "/iMail",
    },
    {
      id: 2,
      title: "News",
      isSelected: false,
      navigate: "/news",
    },
    {
      id: 4,
      title: "Downloaded News",
      isSelected: false,
      navigate: "/downloadedNews",
    },
    {
      id: 3,
      title: "Website Home",
      isSelected: false,
      navigate: "https://www.facebook.com",
    },

    {
      id: 6,
      title: "Learn About Dashboard",
      isSelected: false,
      navigate: "https://www.facebook.com",
    },
  ],
};

export default function loginReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  const { topBarList, chatGroupTitle, chatGroupId } = newState;
  switch (action.type) {
    // LOGIN
    case types.API_LOGIN_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
        token: null,
        signupSuccess: false,
        signupSuccess: false,
        resetEmailSent: false,
        signupErrors: null,
      };

    case types.API_LOGIN_REQUEST_SUCCESS:
      let expiry = dayjs().add(5, "minute").format();
      auth.setToken(
        action?.response?.access,
        action?.action?.data?.isChecked ?? false,
        action?.response?.refresh,
        expiry
      );
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
        token: action?.response?.access,
        isInstructor: action?.response?.role === "instructor",
        refreshToken: action?.response?.refresh,
        tokenExpireTime: expiry,
        userName: action?.response?.username,
        isCardAdded: action?.response?.stripe_connected
      };

    case types.API_LOGIN_REQUEST_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        signupErrors: null,
      };
    // REFRESH_TOKEN
    case types.REFRESH_TOKEN_REQUEST:
      return {
        ...newState,
        isLoading: true,
      };

    case types.REFRESH_TOKEN_SUCCESS:
      let isChecked = localStorage.getItem("user_token");
      let expiry1 = dayjs().add(5, "minute").format();
      auth.setToken(
        action?.response?.access,
        isChecked ?? false,
        action?.response?.refresh,
        expiry1
      );
      return {
        ...newState,
        isLoading: false,
        token: action?.response?.access,
        refreshToken: action?.response?.refresh,
        tokenExpireTime: expiry1,
      };

    case types.REFRESH_TOKEN_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // Signup
    case types.API_SIGNUP_REQUEST:
      return {
        ...newState,
        isLoading: true,
        signupSuccess: false,
        signupErrors: null,
      };

    case types.API_SIGNUP_SUCCESS:
      return {
        ...newState,
        isLoading: false,
        signupSuccess: true,
        signupErrors: null,
      };

    case types.API_SIGNUP_FAILED:
      return {
        ...newState,
        isLoading: false,
        signupSuccess: false,
        signupErrors: action?.response?.response?.data,
      };

    // Request password reset
    case types.API_PASSWORD_RESET_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
        resetEmailSent: false,
      };

    case types.API_PASSWORD_RESET_SUCCESS:
      return {
        ...newState,
        isLoading: false,
        error: null,
        resetEmailSent: true,
      };

    case types.API_PASSWORD_RESET_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        resetEmailSent: false,
      };

    // Request password reset confirm
    case types.API_PASSWORD_RESET_CONFIRM_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
      };

    case types.API_PASSWORD_RESET_CONFIRM_SUCCESS:
      toast.success(action.response?.data?.message);
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
      };

    case types.API_PASSWORD_RESET_CONFIRM_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    case types.SET_USER_INFORMATION:
      return {
        ...newState,
        user_information: action.data,
      };

    case types.CLEAR_TOKEN:
      auth.logout();
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: null,
        token: null,
        user: null,
        isChatOpen: {
          isOpen: false,
          course: {}
        },
      };

    case types.RESET_MSG:
      return {
        ...newState,
        success: false,
        error: null,
      };

    case types.LOGIN_CALLBACK:
      return {
        ...newState,
        loginCallback: action.payload,
      };

    case types.HANDLE_SIDE_BAR_NAVIGATION:
      const iconList = [...topBarList];
      const nav = action?.payload;
      iconList.forEach((f) => {
        if (f.id === nav?.id) {
          f.isSelected = true;
        } else {
          f.isSelected = false;
        }
      });

      return {
        ...newState,
        selectedSideMenu: nav,
        topBarList: iconList,
        chatGroupId: action?.groupId ?? chatGroupId,
        chatGroupTitle: action?.groupTitle ?? chatGroupTitle,
      };

    // GET_PROFILE
    case types.GET_PROFILE_REQUEST:
      return {
        ...newState,
        isLoading: false,
      };
    case types.GET_PROFILE_SUCCESS:
      // console.log("GET_PROFILE_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
        profile: action?.response,
        isCardAdded: action?.response?.stripe_connected
      };
    case types.GET_PROFILE_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // EDIT_PROFILE
    case types.EDIT_PROFILE_REQUEST:
      return {
        ...newState,
        isLoading: true,
      };
    case types.EDIT_PROFILE_SUCCESS:
      // console.log("EDIT_PROFILE_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
        profile: action?.response,
      };
    case types.EDIT_PROFILE_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    case types.SET_OPEN_CHAT:
      return {
        ...newState,
        isChatOpen: {
          isOpen: action.bool,
          course: action.course
        }
      }


    case types.HANDLE_SELECT_USER:
      // console.log("HANDLE_SELECT_USER", action?.payload);
      return {
        ...newState,
        isInstructor: action?.payload,
      };

    default:
      return state;
  }
}
